import { PayloadAction } from '@reduxjs/toolkit';
import { SalesOrganization } from './types';
import { initialState } from './index';

export const reducers = {
  getSalesOrganization(state) {
    state.isLoading = true;
  },
  getSalesOrganizationSuccess(state, action: PayloadAction<SalesOrganization>) {
    state.isLoading = false;
    state.error = null;
    state.data = action.payload;
    state.isAPIComplete = true;
  },
  getSalesOrganizationFail(state, action: PayloadAction<unknown>) {
    state.isLoading = false;
    state.data = initialState.data;
    state.error = action.payload;
    state.isAPIComplete = true;
  },
};
